import Model, { encoders, ID, Integer, JsonArray, MODEL_LEVEL } from 'src/models/Model'
import Screen from 'src/models/screen/Screen'

export const DELIVERY_LOCATION_TYPES = {
  TABLE: 'table',
  THEATER_SEAT: 'theater-seat'
}
DELIVERY_LOCATION_TYPES.ALL = _.values(DELIVERY_LOCATION_TYPES)
Object.freeze(DELIVERY_LOCATION_TYPES)

export const DEFAULT_TABLE_POSITIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'Box']

export default class DeliveryLocation extends Model {
  static name = 'DeliveryLocation'

  static deletable = true
  static duplicatable = true
  static paginate = true
  static isConfiguration = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Kitchen, Model.permissionCategories.PointOfSale]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      shortName: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true,
        default: DELIVERY_LOCATION_TYPES.THEATER_SEAT
      },
      screen: {
        type: Screen,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      positionsPrefix: {
        type: String,
        default: null
      },
      positions: {
        type: JsonArray,
        required: true,
        default: () => { return [] }
      },
      displayOrder: {
        type: Integer,
        required: true,
        default: 100
      },
      allowOpenTabWithQrCode: {
        type: Boolean,
        default: false
      },
      libraryParentId: {
        type: ID,
        output: true
      },
      receiveLibraryUpdates: {
        type: Boolean
      },
      libraryChildSiteIds: {
        type: [ID],
        output: true
      },
      libraryDescendantSites: {
        type: JsonArray,
        output: true
      },
      generateNewPositions: {
        type: Boolean,
        local: true,
        default: false
      }
    }
  }
}
